export const JournalNoteScope=Object.freeze({
  SESSION:'session',
  ITEM:'item'
});

const SCOPES=new Set(Object.values(JournalNoteScope));

function required(value,label,max=4000){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function scope(value){
  const key=String(value||'').trim().toLowerCase();
  if(!SCOPES.has(key))throw new TypeError('Unsupported journal note scope');
  return key;
}

export function createJournalNote({
  scopeKind,
  scopeId,
  userId,
  text
}={}){
  return Object.freeze({
    scopeKind:scope(scopeKind),
    scopeId:required(scopeId,'scopeId',128),
    userId:required(userId,'userId',128),
    text:required(text,'text',4000)
  });
}

export function journalNoteEntityType(scopeKind){
  const kind=scope(scopeKind);
  return kind===JournalNoteScope.SESSION?'journal_session_note':'journal_item_note';
}

export function journalNoteToRow(note){
  const value=createJournalNote(note);
  return Object.freeze(value.scopeKind===JournalNoteScope.SESSION
    ?{session_id:value.scopeId,user_id:value.userId,note:value.text}
    :{item_id:value.scopeId,user_id:value.userId,note:value.text});
}
